import api from '@/apis'
import Vuetify from '@/plugins/vuetify'

export default {
  state: {
    visibility: false
  },
  mutations: {
    INIT_LIVE_VIDEO_CALL_NOTIFICATION(state) {
      state.visibility = true
    },
    RESET_LIVE_VIDEO_CALL_NOTIFICATION(state) {
      state.visibility = false
    }
  },
  actions: {
    async updateNotification({ rootState, commit, dispatch }, payload) {
      try {
        const device_id = rootState.auth.selected_device
        const response = await api.updateNotification({
          device_id: device_id,
          params: {
            notification_channel: payload
          }
        })
        if (response.data.success) {
          dispatch('fetchNotificationChannel', device_id)
          commit('RESET_LIVE_VIDEO_CALL_NOTIFICATION')
          commit('SET_SNACKBAR', { status: true, color: 'success', text: Vuetify.locale.t('$vuetify.__SnackBar.update', ''), icon: 'check', timeout: '2000' })
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      }
    }
  }
}
